import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Independiente } from '../../../models/independiente.model';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
declare var jQuery: any;
declare var $: any;




@Component({
    selector: "page-independiente",
    templateUrl: "./independiente.component.html",
    styleUrls: ["./independiente.component.css"],
    providers: [UserService, FormService]
})

export class IndependienteComponent {

    @ViewChild('openModal', { static: true }) openModal: TemplateRef<any>;
    public isNatural;
    public rut_ind;
    public invalidRut: Boolean;
    public independiente: Independiente;
    public rows = [];
    public actualRow;
    public matcher = new FormService();

    public filteredOptions;
    public nombreComuna = new FormControl('', [Validators.required]);
    options = []
    public selectedInd: number = null;

    constructor(private fb: FormBuilder, private _userService: UserService,
        private rutValidator: RutValidator, private dialog: MatDialog, private spinner: NgxSpinnerService) {

        this.rut_ind = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        })

        if (!JSON.parse(localStorage.getItem("independiente"))) {
            localStorage.setItem("independiente", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("independiente"));
        }
        this.invalidRut = true;

        this.independiente = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' };
    }

    ngOnInit() {
        this.getComunas()
        console.log(this.nombreComuna)
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(
                startWith(''),
                map(value =>
                    this._filter(value))
            );
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }

    get_independiente(rut) {
        var rut_orig = rut;
        var dv;

        if (rut.includes("-")) {
            var fullRut = rut.split("-");
            rut = fullRut[0];
            dv = fullRut[1];
        } else {
            dv = rut
            rut = rut.toString();
            rut = rut.substring(0, rut.length - 1);
            dv = dv.slice(-1);
        }


        console.log("este es el rut limpio", rut)

        if (rut >= 50000000) {
            this.isNatural = false;
        }
        else {
            this.isNatural = true;
        }

        this.spinner.show();
        this.cleanData();
        this._userService.getIndependiente(rut_orig).subscribe(
            response => {
                if (response.message) {
                    this.independiente.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                } else {
                    this.independiente.rut = response.rut ? response.rut : '';
                    this.independiente.nombre = response.nombre ? response.nombre : '';
                    this.independiente.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.independiente.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.independiente.direccion = response.direccion ? response.direccion : '';
                    this.independiente.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.independiente.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.independiente.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.independiente.comuna = response.comuna ? response.comuna : '';
                    this.independiente.fono = response.fono ? response.fono : '';
                    this.independiente.fax = response.fax ? response.fax : '';
                    this.independiente.mail = response.mail ? response.mail : '';
                    this.independiente.patente = response.patente ? response.patente : '';
                    this.independiente.registro = response.registro ? response.registro : '';
                    this.independiente.categoria = response.categoria ? response.categoria : '';
                    this.independiente.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }

    cleanData() {
        this.independiente = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' };
        this.rut_ind.reset()
    }

    update_independiente(rut, id) {
        this.get_independiente(rut);
        this.selectedInd = id;
    }

    saveIndependiente() {
        window.scroll(0, 0);
        //por si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {
            if (this.independiente.rut == this.rows[x].rut) {
                this.delete_independiente(x);
            }
        }

        //elimina fila cuando la editan
        /*if (this.selectedInd != null) {
            this.delete_independiente(this.selectedInd);
            this.selectedInd = null;
        }*/
        this.spinner.show();
        this._userService.saveIndependiente(this.independiente).subscribe(
            response => {
                this.spinner.hide();

                console.log(response)
                if (response.update || response.save) {
                    $("#ind_modal").modal("hide");
                    this.actualRow = localStorage.getItem("independiente");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.independiente.rut,
                        nombre: this.independiente.nombre,
                        apellido_mat: this.independiente.apellido_mat,
                        apellido_pat: this.independiente.apellido_pat,
                        direccion: this.independiente.direccion,
                        direccion_num: this.independiente.direccion_num,
                        direccion_complemento: this.independiente.direccion_complemento,
                        direccion_completa: this.independiente.direccion_completa,
                        comuna: this.independiente.comuna,
                        fono: this.independiente.fono,
                        fax: this.independiente.fax,
                        mail: this.independiente.mail,
                        patente: this.independiente.patente,
                        registro: this.independiente.registro,
                        categoria: this.independiente.categoria
                    })
                    localStorage.setItem("independiente", JSON.stringify(this.rows));
                    this.independiente = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', categoria: '', registro: '', recordId: '' };
                    this.rut_ind.reset();
                    this.dialog.closeAll();

                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }

    delete_independiente(id) {

        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("independiente", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('independiente'));
            }
        }
    }

    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }
}